import React, { useEffect, useState, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { base_url } from '../Api/Api';
import { Link } from 'react-router-dom';
import { Scrollbar } from "react-scrollbars-custom";
import ClipLoader from "react-spinners/ClipLoader";

const Search = (props) => {

    const [loader, setLoader] = useState(false)
    const [state, setState] = useState({
        history: [],
        searchInput: '',
        searchResult: [],
        historyStatus: true,
        popupStatus: false
    })

    useEffect(() => {

        callHistory()

    }, [])

    const searchFunc = (value) => {

        setLoader(true)
        if (value.trim().length > 0) {


            const data = {
                text: value
            }
            base_url.post(`search`, data)
                .then(response => {
                    base_url.get(`searchHistory`)
                        .then(resp => {
                            setState({
                                ...state,
                                history: resp.data.slice(0, 5),
                                searchResult: response.data,
                                searchInput: value,
                                historyStatus: true,
                            })
                            setLoader(false)
                        })
                        .catch(error => {
                            if (error.response != undefined) {
                                if (error.response.status == 401) {
                                    props.history.push(`/entrance`)
                                }
                            }
                        })
                })
                .catch(error => {
                    if (error.response != undefined) {
                        if (error.response.status == 401) {
                            props.history.push(`/entrance`)
                        }
                    }
                })
        } else if (value.length == 0) {
            setState({
                ...state,
                searchInput: value,
                searchResult: [],
                historyStatus: false,
            })
            setLoader(false)
        }

    }

    const callHistory = () => {


        base_url.get(`searchHistory`)
            .then(response => {
                setState({
                    ...state,
                    history: response.data.slice(0, 5),
                    historyStatus: response.data.length == 0
                })
                setLoader(false)
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/entrance`)
                    }
                }
            })
    }

    const searchValue = (e, typeFiled) => {
        if (typeFiled == 'input') {
            searchFunc(e.target.value)
        } else {
            searchFunc(e)
        }
    }

    const clearAllHistory = () => {
        setLoader(true)

        base_url.post(`cleareAllSearch`, {})
            .then(response => {
                setState({
                    ...state,
                    history: [],
                    historyStatus: true,
                })
                setLoader(false)
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/entrance`)
                    }
                }
            })
    }

    const clearSingleHistory = (idItem) => {

        setLoader(true)

        const data = {
            id: idItem
        }
        base_url.post(`cleareSingleSearch`, data)
            .then(response => {
                callHistory()
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/entrance`)
                    }
                }
            })
    }

    const selectHistoryItem = (value) => {
        searchFunc(value)
    }

    return (
        <div className="search-main">
            <div className="input-form">
                <input
                    type="text"
                    placeholder="جستجو ..."
                    // value={state.searchInput}
                    onChange={(e) => searchValue(e, 'input')} />
                {loader ?
                    <div className="loader-search">
                        <ClipLoader color="#152b9f" loading={loader} size={28} />
                    </div>
                    :
                    <i className="icon-search" />
                }
            </div>

            <Scrollbar
                style={{ width: 100 + '%', height: 320 }}>
                <div className="box-result">

                    {state.historyStatus ?
                        null
                        :
                        <div className="style-list search-history">
                            <h4>تاریخچه جستجو <span onClick={clearAllHistory}>پاک کردن همه</span> </h4>
                            <ul>
                                {state.history.length == 0 ? null :
                                    state.history.slice(0, 3).map((info, index) =>
                                        <li key={index} >
                                            <span
                                                onClick={() => selectHistoryItem(info.text)}>
                                                {info.text}
                                            </span>
                                            <i
                                                className="icon-close"
                                                onClick={() => clearSingleHistory(info.id)} ></i>
                                        </li>
                                    )}
                            </ul>
                        </div>
                    }
                    {state.searchResult.length == 0 ? null :

                        (state.searchResult.course.length +
                            state.searchResult.learningContent.length +
                            state.searchResult.webinar) == 0 ?
                            <span className="no-content"> <i className="icon-search"></i> موردی برای جستجو یافت نشد.</span>
                            :
                            < div className="style-list search-history">
                                <h4>دسته بندی</h4>
                                <ul>
                                    {state.searchResult.course.map((info, index) =>
                                        <li
                                            key={info.id}
                                            onClick={() => props.popupStatus(false)} ><Link to={`/education/mycourses/${info.id}`}>{info.title} در <b>کرس درسی</b></Link></li>
                                    )}
                                    {state.searchResult.learningContent.map((info, index) =>
                                        <li
                                            key={info.id}
                                            onClick={() => props.popupStatus(false)} ><Link to={`/education/category/${info.id}`}>{info.title} در <b>محتوای آموزشی</b></Link></li>
                                    )}
                                    {state.searchResult.webinar.map((info, index) =>
                                        <li
                                            key={info.id}
                                            onClick={() => props.popupStatus(false)} ><Link to={`/Webinar/InnerWebinar/${info.id}`}>{info.title} در <b>وبینار</b></Link></li>
                                    )}
                                </ul>
                            </div>
                    }
                </div>
            </Scrollbar>
        </div >
    );
}

export default Search;